import { reduxType } from "../../interfaces/reducerType"
const defaultState: string = "";
function reducer(state = defaultState, { type, payload }: reduxType) {
    switch (type) {
        case "setDomains":
            return payload
        default:
            return state;
    }
}
export default reducer;